<template>
  <div>
    <list-block>
      <el-form
        ref="formData"
        :inline="true"
        :model="formData"
      >
        <h4 style="margin-bottom: 10px;">
          节点通用设置
        </h4>
        <el-row>
          <el-col :span="9">
            <prescription
              :time.sync="formData.executeMaxTime"
              :time-type.sync="formData.timeUnit"
              :disabled="isDetail"
            />
          </el-col>
        </el-row>
        <TaskSetting
          ref="taskTableEl"
          :node-index="2"
          :table-data="formData.ruleFlowTaskItemDetails"
        />
      </el-form>
    </list-block>
  </div>
</template>

<script>
import ListBlock from '@/components/ListBlock/index.vue';
import Prescription from '../../components/Prescription.vue';
import TaskSetting from './TaskSetting.vue';
import { NODE_TYPE } from './constant';

export default {
  components: {
    ListBlock,
    Prescription,
    TaskSetting,
  },
  props: {
    formData: {
      type: Object,
      default: () => {},
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    // 纯获取数据
    getPureTableData() {
      return this.$refs.taskTableEl.getPureTableData();
    },
    resetTaskOptions() {
      return this.$refs.taskTableEl.resetTaskOptions();
    },
    validateForm() {
      /* eslint-disable-next-line */
      return new Promise(async (resolve) => {
        try {
          await this.$refs.formData.validate();
          const tableData = await this.$refs.taskTableEl.getTableData(2);
          resolve(tableData);
        } catch (error) {
          this.$message.warning(`请完善“${NODE_TYPE[2].label}”节点数据`);
        }
      });
    },
  },
};
</script>
